module.exports = __webpack_public_path__ + "static/media/background-OIP.a8820040.jpg";